import { AfterViewInit, Component } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewInit {
  title = 'nedbank-application';

  constructor() {
    if (environment.production) {
      this.loadScript('https://www.googletagmanager.com/gtag/js?id=G-14Q00G71WD');
      this.loadInlineScript(`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-14Q00G71WD');
      `);
    }
  }

  ngAfterViewInit() {
    this.applyPreloadedCSS('clientlib-base');
    this.applyPreloadedCSS('clientlib-site');

    this.loadScript('https://cdn.jsdelivr.net/npm/@popperjs/core@2.9.2/dist/umd/popper.min.js');
    this.loadScript('https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.min.js');
  }

  private applyPreloadedCSS(linkId: string) {
    const link = document.getElementById(linkId) as HTMLLinkElement;
    if (link) {
      // Immediately convert preload -> stylesheet
      link.rel = 'stylesheet';
      link.onload = () => {};
    }
  }

  private loadScript(src: string) {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  private loadInlineScript(content: string) {
    const script = document.createElement('script');
    script.textContent = content;
    document.head.appendChild(script);
  }
}
